import { useState } from "react";
import styles from "./Projects.module.css";
const Projects = () => {
  const [listActive, setListActive] = useState(true);
  return (
    <div className={styles.ProjectContainer}>
      <div className={styles.ProjectsHeading}>
        <div className={styles.ProjectNavigate}>
          <div
            className={
              !listActive ? styles.NavigatebtnActive : styles.Navigatebtn
            }
            onClick={() => {
              setListActive(false);
            }}
          >
            Project Spends
          </div>
          <div className={styles.BorderLeft}></div>
          <div
            className={
              listActive ? styles.NavigatebtnActive : styles.Navigatebtn
            }
            onClick={() => {
              setListActive(true);
            }}
          >
            Project List
          </div>
        </div>
        <div className={styles.NewProjectBtn}>
          <img src={"/pluscircle.svg"} className={styles.AddIcon} />
          Add New Projects
        </div>
      </div>
      <div className={styles.SpendListContainer}>

      </div>
    </div>
  );
};
export default Projects;
